<div>
  <div
    nbTooltip="{{ renderValue | titlecase }}"
    class="dot"
    [ngClass]="{
      'dot-blue': renderValue === statuses.ACTIVE,
      'blob-green': renderValue === statuses.RUNNING,
      'dot-green': renderValue === statuses.SUCCESS,
      'dot-gray': renderValue === statuses.INACTIVE,
      'blob-red': renderValue === statuses.FAIL
    }"
  ></div>
</div>
